<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large">Advisories</div>
      </div>
    </div>
    <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
      <div v-if="!showError">
        <cert-progress-indicator v-if="alertList==null"/>
        <div class="row mx-0" v-if="alertList!=null">
          <div v-for="(item,index) in alertList" :key="index" class="my-2 my-xl-0 col-12 col-xl-4">
            <cert-alert-card :id="item.uid" :title="item.title" :date="item.datetime?.human"
                             :image="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(item.images?.[0]?.url)}`"
                             type="advisories"/>
          </div>
          <div style="height: 36px" class="d-sm-none d-block"></div>
        </div>
      </div>
      <cert-color-box v-if="showError" title="Articles could not be loaded" icon="error_outline"/>
    </div>
  </div>
</template>

<script>
import CertColorBox from "@/views/cert/components/CertColorBox";
import CertProgressIndicator from "@/views/cert/components/CertProgressIndicator";
import CertAlertCard from './components/CertAlertCard.vue';

import api from "@/api";
import horusBase64 from "@/components/horusBase64";


export default {
  name: "AlertList",
  computed: {
    horusBase64() {
      return horusBase64
    }
  },
  components: {
    CertAlertCard,
    CertColorBox,
    CertProgressIndicator,
  },
  data() {
    return {
      alertList: null,
      showError: false,
      baseUrlCyber: process.env.VUE_APP_BASE_URL_CYBER,
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  methods: {
    loadAlerts() {
      api
          .get(`${process.env.VUE_APP_BASE_URL}proxy/${horusBase64.stringToBase64URLSafe("api/advisories")}`)
          .then((response) => {
            this.showError = false;
            this.alertList = response.data?.items;
          })
          .catch((error) => {
            error;
            this.showError = true;
          });
    },
  },
  created() {
    this.loadAlerts();
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
  }
};
</script>

